import { useState, } from 'react';
import { useNavigate, } from 'react-router-dom';
import { alpha, } from '@mui/material/styles';
import {
    Menu,
    MenuItem,
    Button,
    Box,
    ListItemIcon,
    ListItemText, } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { useApp, useAuth, } from '../../hooks';
import CustomLink from '../custom-link';

const StyledMenu = (props) => {
    return (
        <Menu
            elevation={0}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            transformOrigin={{
                horizontal: 'left',
                vertical: 'top',
            }}
            sx={{
                '& .MuiPaper-root': {
                    bgcolor: 'background.paper',
                    border: 1,
                    borderColor: 'borderColor.main',
                    boxShadow: 2,
                    minWidth: 180,
                    mt: 1,
                    p: 0,
                    '&:hover': {
                        boxShadow: 5,
                    },
                    '& .MuiMenu-list': {
                        py: 0.5,
                    },
                    '& .MuiMenuItem-root': {
                        '&:hover': {
                            bgcolor: 'transparent',
                            '& .MuiSvgIcon-root, & .MuiButton-root .MuiListItemText-root, & .MuiLink-root .MuiListItemText-root': {
                                color: 'secondary.main',
                            },
                        },
                        '& .MuiLink-root': {
                            alignItems: 'center',
                            display: 'flex',
                            width: '100%',
                            '& .MuiListItemText-root': {
                                fontSize: 14,
                            },
                            '& .MuiListItemIcon-root': {
                                minWidth: 'auto',
                                mt: '-2px',
                                mr: 1.5,

                                '& .MuiSvgIcon-root': {
                                    fontSize: 20,
                                },
                            },
                        },
                        '& .MuiButton-root': {
                            justifyContent: 'flex-start',
                            lineHeight: 1.5,
                            p: 0,
                            width: '100%',
                            '&:hover': {
                                bgcolor: 'transparent',
                                '& .MuiListItemText-root': {
                                    color: 'secondary.main',
                                },
                            },
                            '& .MuiListItemText-root': {
                                color: 'text.primary',
                                flexGrow: 0,
                                fontSize: 14,
                            },
                            '& .MuiListItemIcon-root': {
                                minWidth: 'auto',
                                mt: '-2px',
                                mr: 1.5,
                                '& .MuiSvgIcon-root': {
                                    fontSize: 20,
                                },
                            },
                        },
                        '&:active': {
                            bgcolor: (theme) => alpha(
                                theme.palette.text.secondary,
                                theme.palette.action.selectedOpacity,
                            ),
                        },
                    },
                },
            }}
        {...props}
    />);
};

export default function CreateCustomizedMenu({ sx = [], ...props }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const { newFolderModalOpen, } = useApp();
    const { user, } = useAuth();
    const navigate = useNavigate();

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Box sx={[
            ...(Array.isArray(sx) ? sx : [sx])
        ]} {...props}>
            <Button
                id='create-customized-button'
                aria-controls='create-customized-menu'
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                variant='outlined'
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                    border: 1,
                    borderColor: 'borderColor.main',
                    color: 'text.primary',
                    '&:hover': {
                        border: 1,
                        borderColor: 'secondary.main',
                        color: 'secondary.main',
                    },
                }}>
                Создать
            </Button>
            <StyledMenu
                id='create-customized-menu'
                MenuListProps={{
                    'aria-labelledby': 'create-customized-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuItem
                    onClick={handleClose}>
                    <CustomLink to='/set/create'>
                        <ListItemIcon>
                            <AutoAwesomeMotionIcon />
                        </ListItemIcon>
                        <ListItemText disableTypography>Сет карточек</ListItemText>
                    </CustomLink>
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        handleClose();
                        (user) ? newFolderModalOpen() : navigate('/login');
                    }}>
                    <Button>
                        <ListItemIcon>
                            <CreateNewFolderIcon />
                        </ListItemIcon>
                        <ListItemText disableTypography>Папка</ListItemText>
                    </Button>
                </MenuItem>
            </StyledMenu>
        </Box>
    );
};